import React, { useRef } from 'react';
import { Popover } from 'antd';
import Text from 'components/Text';
import {
  CustomerInfoPopoverUI,
  IconInfo,
} from 'features/user/widgets/WaitingList/WalkIn/components/CustomerName';
import styled from 'styled-components';
import PinCodeModal, { PinCodeModalRef } from './PinCodeModal';
import useControlCustomerInfoPopover from '../hooks/useControlCustomerInfoPopover';

type CustomerPopoverCheckPinCodeProps = {
  customerName: string;
  customerId: string;
  content?: any;
};

const CustomerPopoverCheckPinCode = ({
  customerName,
  customerId,
  content,
}: CustomerPopoverCheckPinCodeProps) => {
  const pinCodeModalRef = useRef<PinCodeModalRef>(null);
  const {
    customerInfo,
    customerDetailLoading,
    open,
    pinData,
    onEdit,
    handleClose,
    handleOpenAfterCheckPinCode,
  } = useControlCustomerInfoPopover(customerId);

  const handleClickOpen = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    if (!customerId) return;
    pinCodeModalRef.current?.open((data) => {
      handleOpenAfterCheckPinCode(data);
    });
  };

  const overlayInnerStyle = { padding: 16, borderRadius: 8, background: '#E4F4F6' };

  return (
    <>
      <WrapperInfoBox onClick={handleClickOpen}>
        <div className='content'>
          <Popover
            placement='rightTop'
            title={null}
            content={
              <div onClick={(e) => e.stopPropagation()}>
                <CustomerInfoPopoverUI
                  loading={customerDetailLoading}
                  customerInfo={customerInfo}
                  onOpenChange={handleClose}
                  onEdit={onEdit}
                  dataPin={pinData}
                />
              </div>
            }
            open={open}
            trigger={'click'}
            overlayInnerStyle={overlayInnerStyle}
          >
            <ButtonInside type='button'>
              {
                content ? content : <>
                  {!!customerId && <IconInfo />}
                  <Text variant='H7' color='text_3' className='text-overflow'>
                    {customerName || 'Unknown'}
                  </Text>
                </>
              }
            </ButtonInside>
          </Popover>
        </div>
      </WrapperInfoBox>
      <PinCodeModal ref={pinCodeModalRef} title='ADMIN PASSWORD' />
    </>
  );
};

export default CustomerPopoverCheckPinCode;

const WrapperInfoBox = styled.div`
  flex: 1;
  position: relative;
  align-self: stretch;
  }
  .content {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
`;

const ButtonInside = styled.button`
  flex: 1;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 2px;
`;
